<div class="container">
    <app-shell 
        style="width: 100%; height: 100%;" 
        [needsProgressBars]="false"
        [homeState]="homeState"
        [fpState]="fpState"
        [cpState]="cpState"
        [disableDocuments]="disableDocuments"
    >
        <div class="dashboard-grid">
            <div class="dashboard-hero tile ">
                <h1 [innerHTML]="this.mainHeaderText"></h1>
                <p [innerHTML]="this.mainSummaryText"></p>
                <h2 [innerHTML]="this.mainSubHeaderText"></h2>
                <p [innerHTML]="this.mainSubSummaryText"></p>
                <div class="rescore-buttons" *ngIf="this.rescoreEligabilityBit">
                    <div class="button-wrapper modify">
                        <app-stateful-primary-button
                            text="Modify Business Profile"
                            [pageUrl]="this.modifyBpState['pageUrl']"
                            [stateId]="this.modifyBpState['id']"
                            [clickEvent]="this.modify.bind(this)"
                        ></app-stateful-primary-button>
                    </div>
                    <div class="button-wrapper recheck">
                        <app-primary-button 
                            text="Recheck Eligibility"
                            [clickEvent]="this.rescore.bind(this)"
                        ></app-primary-button>
                    </div>
                </div>
            </div>

            <div class="dashboard-info tile">
                <h2>Grow Fearlessly</h2>
                <p>Explore <a href="https://nowcorp.com/clients/">NowAccount</a></p>
                <p>Expand with <a href="https://nownetwork.nowcorp.com/">NowNetwork</a></p>
            </div>

            <div class="dashboard-contact tile">
                <h4>Now Representative</h4>
                <img 
                    src="\assets\images\Icon_ionic-md-contact.svg" 
                    alt="Now Representative Icon"
                    width="40"
                    height="40"
                />
                <p>sales@nowcorp.com</p>
                <p>(855) 966-9435</p>
                <!-- <a href="/support/case">Tech Support</a> -->
            </div>
        </div>
    </app-shell>
</div> 